import e from'./../../../../ext-esm/style-inject/dist/style-inject.es.js';var t={bhaFeedItemInfoWrapper:"styles_bhaFeedItemInfoWrapper__wwhNF"};e(".styles_bhaFeedItemInfoWrapper__wwhNF{display:flex}");export{t as default};
